import { render, staticRenderFns } from "./btn-wrapper.vue?vue&type=template&id=44841854&scoped=true&lang=pug&"
import script from "./btn-wrapper.vue?vue&type=script&lang=js&"
export * from "./btn-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./btn-wrapper.vue?vue&type=style&index=0&id=44841854&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44841854",
  null
  
)

export default component.exports